"use client";

import NextImage from "next/image";
import LogoIntenser from "@/components/LogoIntenser";
// import CookieSettingsButton from "./CookieSettingsButton";
import Dribbble from "@/components/Dribbble";
import Instagram from "@/components/Instagram";
import LinkedIn from "@/components/LinkedIn";
import GitHub from "@/components/GitHub";
import useSound from "use-sound";
import { useTranslations } from "next-intl";
import CookieSettingsButton from "@/components/CookieSettingsButton";
import LanguageSwitch from "@/components/LanguageSwitch";

function ScrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

export default function Footer() {
  const t = useTranslations("footer");
  const [debiddo] = useSound("/debiddo.mp3");
  const [deivu] = useSound("/deivu.mp3");

  return (
    <footer className="relative w-full h-56 text-white z-60 rounded-t-2xl -mt-10 overflow-hidden">
      <NextImage
        src="/images/footer_bg.jpg"
        alt=""
        fill
        className="object-cover"
        sizes="100vw"
      />
      <div className="absolute top-8 left-8 flex items-stretch">
        <div className="border border-white/15 p-4 w-32 rounded-l-lg flex items-center justify-center">
          <LogoIntenser
            onClick={() => ScrollToTop()}
            className="w-full h-full hover:scale-110 active:scale-95 transform-all ease-in-out duration-300 cursor-pointer"
          />
        </div>
        <div className="hidden md:flex border-t border-b border-r border-white/15 py-4 px-6 flex-col items-center text-red-600 font-heading text-2xl leading-7 uppercase">
          <button
            onClick={() => debiddo()}
            className="cursor-pointer select-none hover:scale-110 active:scale-95 transition-all duration-300 ease-in-out flex flex-col items-center"
          >
            <span>デビ</span>
            <span>ッド</span>
          </button>
        </div>
        <div className="hidden md:flex border-t border-b border-white/15 py-4 px-6 items-center text-white font-mono text-sm uppercase">
          Ai-Modified
        </div>
        <div className="hidden lg:flex border-l border-t border-b border-white/15 pl-6 pr-20 py-4 flex-col justify-center gap-1 text-white font-mono uppercase">
          <p className="text-xs leading-4">Version</p>
          <p className="text-xl leading-6">7.2.0</p>
        </div>
        <div className="bg-white rounded-r-lg py-1 px-2 flex flex-col items-center justify-center text-black font-heading text-xl leading-6 uppercase">
          <button
            onClick={() => deivu()}
            className="cursor-pointer select-none hover:scale-110 active:scale-95 transition-all duration-300 ease-in-out flex flex-col items-center"
          >
            <span>デ</span>
            <span>イ</span>
            <span>ヴ</span>
          </button>
        </div>
      </div>
      <div className="absolute top-8 right-8 flex items-center max-w-48 flex-wrap gap-2 justify-end">
        <a
          href="https://www.linkedin.com/in/dhof/"
          target="_blank"
          rel="noreferrer noopener"
          aria-label="LinkedIn"
          className="shrink-0 w-8 h-8 text-white/80 hover:text-white transition-all duration-300 ease-in-out"
        >
          <LinkedIn className="w-full h-full" />
        </a>
        <a
          href="https://dribbble.com/intenser"
          target="_blank"
          rel="noreferrer noopener"
          aria-label="Dribbble"
          className="shrink-0 w-8 h-8 text-white/80 hover:text-white transition-all duration-300 ease-in-out"
        >
          <Dribbble className="w-full h-full" />
        </a>
        <a
          href="https://www.instagram.com/dave.hope/"
          target="_blank"
          rel="noreferrer noopener"
          aria-label="Instagram"
          className="shrink-0 w-8 h-8 text-white/80 hover:text-white transition-all duration-300 ease-in-out"
        >
          <Instagram className="w-full h-full" />
        </a>
        <a
          href="https://github.com/intensr"
          target="_blank"
          rel="noreferrer noopener"
          aria-label="GitHub"
          className="shrink-0 w-8 h-8 text-white/80 hover:text-white transition-all duration-300 ease-in-out"
        >
          <GitHub className="w-full h-full" />
        </a>
        <LanguageSwitch />
      </div>
      {/* <p className="hidden md:block absolute bottom-8 left-8 text-xs text-white/60 w-[calc(100%-64px)]">
        Hommage "Baron Dave" to{" "}
        <a
          href="https://en.wikipedia.org/wiki/Vladimir_Harkonnen"
          className="underline"
        >
          Dune's Baron Harkonnen
        </a>
        , illustrated by{" "}
        <a
          href="https://dune.fandom.com/wiki/John_Schoenherr"
          className="underline"
        >
          John Schoenherr
        </a>
      </p> */}
      <p className="absolute bottom-8 right-8 text-xs text-white/60 flex gap-4 font-mono">
        {t
          .raw("links")
          .map((link: { link: string; linktitle: string }, index: number) => (
            <a
              key={index}
              className="hover:text-white transition-all duration-300 ease-in-out"
              href={link.link}
            >
              {link.linktitle}
            </a>
          ))}
        <CookieSettingsButton />
      </p>
    </footer>
  );
}
